import { createElement } from 'react'
import { Table } from 'shared/components'
import { FlagCell } from 'routes/shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { allBeneficiariesFavorite } from './components/favoriteButton'

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
    width: 72,
    minWidth: 72,
  },
  {
    Header: 'Beneficiary Name',
    accessor: 'beneficiaryName',
    width: 400,
    minWidth: 400,
  },
  {
    Header: 'Categories',
    accessor: 'category',
    Cell: (props) =>
      createElement(Table.CellRenderers.StringListCell, {
        ...props,
        valueTransformer: ({ description }) => description,
      }),
    width: 200,
    minWidth: 200,
  },
  {
    Header: 'Sub Category',
    accessor: 'subCategory',
    Cell: (props) =>
      createElement(Table.CellRenderers.StringListCell, {
        ...props,
        valueTransformer: ({ description }) => description,
      }),
    width: 200,
    minWidth: 200,
  },
  {
    Header: 'Jurisdiction',
    accessor: 'jurisdiction.logo',
    Cell: FlagCell,
  },
  {
    Header: 'Website',
    accessor: 'website',
    Cell: Table.CellRenderers.LinkCell,
    width: 400,
    minWidth: 400,
  },
  {
    Header: 'Total Amount',
    accessor: 'allTimeInWins',
    Cell: Table.CellRenderers.MoneyValueCell,
  },
  {
    Header: 'Favorite',
    id: 'controls',
    width: 180,
    minWidth: 180,
    accessor: (value) => value,
    Cell: (props) => createElement(allBeneficiariesFavorite, { ...props }),
  },
]
